/*=========================================================================================
  File Name: betActions.js
  Description: bet Module Actions
==========================================================================================*/

export default {
  /**
   * Submit Betting
   *
   */
  async betSubmit({ commit, rootState }, betData) {
    var incomingBets = betData.currentbettings;
    if (rootState.betModule.bettings.length > 0) {
      if (betData.bettings.length > 0) {
        var currentBettings = rootState.betModule.bettings;

        currentBettings.forEach((key, item) => {
          const checkIfBetposExist = betData.bettings.some(
            (o) => o.betpos === currentBettings[item].betpos
          );

          if (checkIfBetposExist) {
            const idx = betData.bettings.findIndex(
              (b) => b.betpos == currentBettings[item].betpos
            );
            var newAmount =
              parseInt(betData.bettings[idx].betamt) +
              parseInt(currentBettings[item].betamt);
            betData.bettings[idx].betamt = newAmount;
            betData.totalBetAmount += parseInt(currentBettings[item].betamt);
          } else {
            var betObj = {
              betpos: currentBettings[item].betpos,
              betamt: currentBettings[item].betamt,
            };
            betData.totalBetAmount += currentBettings[item].betamt;
            betData.bettings.push(betObj);
          }
        });
      }
    }

    // COMMIT BETTING
    commit('SET_BETTING', betData);

    this._vm.$socket.client.emit('bet_submit', {
      level: betData.level,
      currency: betData.currency,
      bettings: incomingBets,
    });
  },
  /**
   * Cancel Betting
   *
   */
  async betCancel() {
    this._vm.$socket.client.emit('bet_cancel', {});
  },
  /**
   * Clear Bet
   *
   */
  async betClear({ commit }) {
    commit('CLEAR_BETTING');
  },
  /**
   * Refresh Balance
   *
   */
  async refreshBalance() {
    this._vm.$socket.client.emit('balance');
  },
  /**
   * Rollback Betting
   *
   */
  async betRollback({ commit }) {
    // CANCEL BETTING
    commit('ROLLBACK_BETTING');
  },
};
